import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
const root = document.getElementById('root');
if (root) {
  createRoot(root).render(<React.StrictMode data-id="element-316">
      <App data-id="element-317" />
    </React.StrictMode>);
}